import React, { useState } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";

const ConvoFooter = ({ scrollToLastMsg }) => {
    const [message, setMessage] = useState("");

    const handleSend = () => {
        if (message.trim()) {
            setMessage("");
            if (scrollToLastMsg) {
                scrollToLastMsg();
            }
        }
    };

    return (
        <div
            style={{
                padding: "12px 16px",
                backgroundColor: "#ffffff",
                borderTop: "1px solid #e2e8f0",
            }}
        >
            <InputGroup size="sm">
                <Form.Control
                    placeholder="Type message..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSend();
                        }
                    }}
                />
                <Button
                    variant="primary"
                    onClick={handleSend}
                    disabled={!message.trim()}
                >
                    <i className="fas fa-paper-plane"></i> Send
                </Button>
            </InputGroup>
        </div>
    );
};

export default ConvoFooter;
